<template>
  <div class="pages">
    <van-tabs v-model="active" title-active-color="#FF6464" color="#FF6464" @click="getdata">
      <van-tab title="已使用">
        <div class="contents1">
          <van-empty description="暂时没有没有使用优惠卷！" v-if="this.list==null || this.list.length==0"/>
          <div class="item" v-for="item in list" >
            <div class="item_left">
              <div class="item_left1">
                <span>{{item.name}}</span>
              </div>
              <div class="item_left2">
                <span>有效期：{{item.startAt}}~{{item.endAt}}使用条件：{{item.condition}}</span>
              </div>
            </div>
            <div class="item_right">
              <span>已使用</span>
            </div>
          </div>
<!--          <div class="null" v-if="!list.def">-->
<!--            <img src="./null.png">-->
<!--            <span>暂无信息!</span>-->
<!--          </div>-->
        </div>
        <!--<div class="contents2" v-if="show==1">-->
        <!--<span>您还没有优惠券～</span>-->
        <!--<dl>前往领券中心</dl>-->
        <!--</div>-->
      </van-tab>
      <van-tab title="未使用">
        <div class="contents1">
          <van-empty description="暂时没有优惠卷！" v-if="this.list==null || this.list.length==0"/>
          <div class="item" v-for="item in list" >
            <div class="item_left">
              <div class="item_left1">
                <span>{{item.name}}</span>
              </div>
              <div class="item_left2">
                <span>有效期：{{item.startAt}}~{{item.endAt}}使用条件：{{item.condition}}</span>
              </div>
            </div>
            <div class="item_right">
              <span>使用</span>
            </div>
          </div>
        </div>
      </van-tab>
      <van-tab title="已过期">
        <div class="contents1">
          <van-empty description="暂时没有优惠卷！" v-if="this.list==null || this.list.length==0"/>
          <div class="item" v-for="item in list" >
            <div class="item_left">
              <div class="item_left1">
                <span>{{item.name}}</span>
              </div>
              <div class="item_left2">
                <span>有效期：{{item.startAt}}~{{item.endAt}}使用条件：{{item.condition}}</span>
              </div>
            </div>
            <div class="item_right">
              <span>已过期</span>
            </div>
          </div>
        </div>
      </van-tab>
    </van-tabs>
  </div>
</template>

<script>
    export default {
        data() {
            return {
                active: 0,
                show: 0,
                list: []
            }
        },
        created() {
            this.getdata()
        },
        methods: {
            getdata() {
                this.myrequest({
                    url: '/client/getmycouponlist.action',
                    types: 'get',
                    data: {
                        // token: this.$store.state.token,
                        types:this.active
                    },
                    succ: (res) => {
                        this.list=res.list
                    },
                    errs: (msg) => {

                    }
                })
            },
        }
    }
</script>

<style scoped lang="stylus">
  .pages {
    width 100%
    background-color #f1f1f1;
    height 100%;
    position absolute;

    .contents1 {
      width 100%

      .item {
        width 95%
        margin 10px auto
        min-height 80px
        max-height 1000px
        background-color #fff
        display flex
        align-items center
        justify-content center

        .item_left {
          flex 0 0 70%

          .item_left1 {
            width 80%
            margin 0 auto
            min-height 30px
            max-height 1000px
            display flex
            align-items center

            span {
              font-size: 14px;
              font-weight 700
              color: #333
              margin-top 8px
            }

            p {
              width 50px
              height 15px
              background-color #F82A5E
              font-size 10px
              color #fff
              text-align center
              line-height 15px
              border-radius 4px
              margin 8px 0 0 5px
            }
          }

          .item_left2 {
            width 80%
            margin 0 auto
            min-height 30px
            max-height 1000px
            display flex
            align-items center
            justify-content center


            span {
              font-size: 12px;
              color: rgba(153, 153, 153, 1);
              margin-top 5px
              margin-bottom 5px
            }
          }
        }

        .item_right {
          flex 0 0 29%
          min-height 70px
          max-height 1000px
          display flex
          align-items center
          justify-content center
          border-left 1px #DDDDDD dashed


          span {
            font-size: 14px;
            font-weight 400
            color: rgba(21, 180, 178, 1);
          }
        }
      }
      .null {
        width 100%
        height 200px;
        display flex
        align-items center
        justify-content center
        flex-direction column

        img {
          width 140px
        }

        span {
          font-size 15px;
          margin-top 10px
          color #A4A4A4;
        }
      }
    }

    .contents2 {
      width 100%
      height 400px
      margin-top 50px
      display flex
      align-items center
      justify-content center
      flex-direction column

      span {
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: rgba(153, 153, 153, 1);
        margin 20px 0 20px 0
      }

      dl {
        width 120px
        height 30px
        border 1px #FF4040 solid
        line-height 30px
        text-align center
        color #FF4040
        font-size 15px
        border-radius 20px
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/wode/coupons.vue